import { Button } from '@mui/material'
import { Title } from 'modules/product/UploadProducts/ArtisanUploadProducts'
import ProductListTable from '../ProductListTable'
import { ProductCreation, ProductCreationWithErrors } from '@Arti-zen/package-backoffice'
import { Theme } from 'theme/theme'

type TProps = {
  products: ProductCreation[]
  correctProduct: ({
    corrections,
    product,
    index,
  }: {
    corrections: Partial<ProductCreationWithErrors>
    product: ProductCreationWithErrors
    index: number
  }) => void
  openForm: (product: ProductCreation, index: number) => void
  deleteProduct: ({ index, from }: { index: number; from: 'products' | 'productsWithErrors' }) => void
  onSubmit: () => Promise<void>
  disableButton: boolean
  onModify: boolean
}

export default function ViewProducts({
  products,
  correctProduct,
  openForm,
  deleteProduct,
  onSubmit,
  disableButton,
  onModify,
}: TProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flex: 1,
      }}
    >
      <>
        <Title>Produits à importer : {products?.length ?? '0'}</Title>
        <ProductListTable
          data={products ?? []}
          correctProduct={correctProduct}
          openForm={openForm}
          deleteProduct={(index: number) => deleteProduct({ index, from: 'products' })}
          onModify={onModify}
        />
      </>
      <Button
        onClick={onSubmit}
        style={{
          display: 'flex',
          alignSelf: 'center',
          backgroundColor: disableButton ? Theme.colors.greyLight : Theme.colors.blueArtizen,
          color: 'white',
          width: '100%',
          margin: '30px 0',
        }}
        disabled={disableButton}
      >
        {onModify ? 'Modifier' : 'Importer'} {products?.length ?? ''} produit{products?.length > 1 ? 's' : ''}
      </Button>
    </div>
  )
}
